import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { UserGroupsCreate } from 'components/Settings/Components/UserGroups/components/userGroupsCreate';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const UserGroupsCreatePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userGroupsNew.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.userGroupsNew.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <UserGroupsCreate />
            </MainContent>
        </PageContainer>
    );
};
